import { buttonVariants } from "@markeroo/theme";
import { Card } from "./Card";
import { ui } from "@/strings";
import { assignmentLabels } from "@/strings/labels";

interface StudentSubmissionCardProps {
  /** Name of the student who hasn't submitted */
  studentName: string;
  /** Callback when "Upload Paper" button is clicked */
  onUpload?: () => void;
  /** Whether the card should be disabled (e.g., GC-synced assignments) */
  disabled?: boolean;
}

/**
 * Card displaying a student who hasn't submitted a paper yet.
 * Shows a grayed-out placeholder with an optional upload button.
 *
 * In manual mode: Shows "Upload Paper" button (not grayed out, stands out)
 * In GC mode: No upload button (papers sync from Google Classroom)
 */
export function StudentSubmissionCard({
  studentName,
  onUpload,
  disabled = false,
}: StudentSubmissionCardProps) {
  const showUploadButton = onUpload && !disabled;

  return (
    <Card data-testid="student-submission-card">
      <Card.Content className="opacity-50">
        <Card.Title>{studentName}</Card.Title>
        <Card.Subtitle className="mt-1">
          {assignmentLabels.noSubmissionYet}
        </Card.Subtitle>
      </Card.Content>

      {showUploadButton && (
        <Card.Actions>
          <button
            type="button"
            className={`${buttonVariants.secondary} w-full sm:w-auto`}
            onClick={onUpload}
          >
            {ui.actions.addPaper}
          </button>
        </Card.Actions>
      )}
    </Card>
  );
}
